define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/server_select2_view",
    "views/common/account_no_select2_view",
    "views/common/chartjs_view",
    "views/common/chartjs_utils",
    "views/common/chartjs_options",
], function($, _, Marionette, ServerSelect2View, AccountNoSelect2View, ChartView, chartUtils, chartOptions){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'filters': '.filter',
            'filterBtn': '#filter_btn',
            'serverDropdown': '#server',
            'accountNoDropdown': '#account_no',
        },

        events: {
            'click @ui.filterBtn': 'redirectToMt4User',
            'change @ui.serverDropdown': 'requestAccountNos',
        },

        regions: {
            'select2Server': '#select2_server',
            'select2Mt4Members': '#select2_mt4_members',
            'chart': '#chart'
        },

        requestAccountNos: function() {
            this.AccountNoSelect2View.requestAccountNos(Number(this.ui.serverDropdown.val()));
        },

        redirectToMt4User: function(){
            if(this.AccountNoSelect2View.getValue() != null){
                window.location = "/client_status/traders_status_individual/"+this.AccountNoSelect2View.getValue();
            }
        },

        initialize: function (options) {
            this.account_no = window.account_no || null;

            var that = this;
            this.bindUIElements();

            this.serverSelect2View = new ServerSelect2View({
                select2El: this.ui.serverDropdown,
            });
            this.AccountNoSelect2View = new AccountNoSelect2View({
                select2El: this.ui.accountNoDropdown,
            });

            this.chartView = new ChartView({
                pagination: {
                    navigation : false
                },
                ajax:{
                    url: '/rest_client_status/trader_status_individual_chart',
                    method: "POST",
                    prepareData: function(){
                        var data = [];
                        data['account_no'] = that.account_no;

                        return data;
                    },
                    parseChartData: function ({ data }) {
                        const sortedData = [...data].sort((a, b) => (-a.value + +b.value));
                        return {
                            labels: sortedData.map((el) => el.name),
                            datasets: [
                                {
                                    ...chartOptions.pieChartDatasetOptions,
                                    label: "Trading status individual chart",
                                    data: sortedData.map((el) => el.value),
                                },
                            ],
                        };
                    }
                },
                chartType: 'pie',
                chartOptions: chartOptions.pieChartOptions,
                chartPlugins: [chartUtils.PieLabels, chartUtils.PieLegend],
            });
            this.showChildView('chart', this.chartView);

        }
    });
});
